/**
 * Predefined payment terms used across Suppliers, POs, and AR reporting.
 * The value is stored as an integer in `customers.payment_terms_days` and
 * `purchase_orders.due_date` is derived from `invoice_date + days`.
 *
 * Labels are display-only — never store the label text in the DB.
 * Use `paymentTermsLabel(days)` to render a friendly string from the days value.
 */
export interface PaymentTermsOption {
  value: number;       // Days from invoice date (0 = due immediately)
  label: string;       // Display label
}

export const PAYMENT_TERMS_OPTIONS: PaymentTermsOption[] = [
  { value: 0,   label: 'COD (Cash on Delivery)' },
  { value: 7,   label: 'NET 7' },
  { value: 14,  label: 'NET 14' },
  { value: 21,  label: 'NET 21' },
  { value: 30,  label: 'NET 30' },
  { value: 45,  label: 'NET 45' },
  { value: 60,  label: 'NET 60' },
  { value: 90,  label: 'NET 90' },
];

/**
 * Render a friendly label for a stored days value. Falls back to "NET X"
 * for any non-standard value (so legacy/imported data still reads cleanly).
 */
export function paymentTermsLabel(days: number | null | undefined): string {
  if (days == null) return '—';
  if (days === 0) return 'COD';
  const match = PAYMENT_TERMS_OPTIONS.find((o) => o.value === days);
  if (match) return match.label.replace(' (Cash on Delivery)', '');
  return `NET ${days}`;
}
